import React from "react";
import { BadgeCheck } from "lucide-react";
import imgrd5 from "../../../assets/Images/r-d/rd_3.jpg";
import imgrd6 from "../../../assets/Images/r-d/rd_6.jpg";



const Research_Development_fifth = () => {
  const regulatoryPoints = [
    "Rapid disintegration technology",
    "Moisture-resistant formulations",
    "High active ingredient compatibility",
    "Vitamin & electrolyte stabilization",
    "Sugar-free and clean-label solutions",
    "Export-compliant manufacturing standards",
  ];

  const qualityLeft = [
    "Controlled humidity manufacturing zones",
    "High-speed effervescent tablet compression machines",
    "Granulation & blending systems",
    "Tube filling & packaging lines",
  ];

  const qualityRight = [
    "Stability testing chambers",
    "Dissolution analysis",
    "Hardness & friability testing",
    "Packaging integrity testing",
  ];

  return (
    <section className="text-center w-full bg-white py-12 md:py-16 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-6">

        {/* Top Row */}
        <div className="text-center grid grid-cols-1 lg:grid-cols-1 gap-10 lg:gap-12 items-center mb-16 md:mb-24">

          {/* Image */}
          <div className="relative">
            <img
              src={imgrd5}
              alt="Regulatory Documentation"
              className="w-full h-[280px] sm:h-[420px] object-cover rounded-[40px]"
            />
          </div>

          {/* Content */}
          <div>

            {/* Main Heading */}
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif text-[#355931] leading-tight text-center">
              Advanced Effervescent Tablet {" "}
              <span className="bg-gradient-to-r from-[#355931] via-[#6b8f4e] to-[#A9C32C] bg-clip-text text-transparent">
                Research & Manufacturing
              </span>
            </h2>

            {/* Description */}
            <p className="text-center mt-6 text-gray-500 text-sm md:text-base leading-7 max-w-5xl mx-auto">
              At Nutralike, effervescent tablet development is one of our core
              manufacturing specializations. Our dedicated R&D and production
              infrastructure is designed to develop high-performance
              effervescent formulations with superior stability, rapid
              dissolution, enhanced taste masking, and optimized nutrient
              delivery.
            </p>

            <p className="mt-5 text-center text-gray-500 text-sm md:text-base leading-7 max-w-5xl mx-auto">
              With advanced machinery, controlled production environments, and
              scientific formulation expertise, we provide end-to-end
              effervescent tablet solutions for nutraceutical, wellness, sports
              nutrition, and pharmaceutical support products.
            </p>

            {/* Points */}
            <div className="mt-8 space-y-5 max-w-4xl mx-auto">
              {regulatoryPoints.map((item, index) => (
                <div
                  key={index}
                  className="flex items-start justify-center gap-3 text-center"
                >
                  <BadgeCheck
                    size={20}
                    className="text-[#355931] mt-1 shrink-0"
                  />

                  <p className="text-gray-700 text-sm md:text-base leading-6 max-w-2xl">
                    {item}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Middle Row */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 items-center mb-12">

          {/* Left Content */}
          <div className="text-left">

            {/* Heading */}
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif text-[#355931] leading-tight">
              Precision Quality Control for{" "}
              <span className="bg-gradient-to-r from-[#355931] via-[#6b8f4e] to-[#A9C32C] bg-clip-text text-transparent">
                Reliable Manufacturing
              </span>
            </h2>

            {/* Description */}
            <p className="mt-6 text-gray-500 text-sm md:text-base leading-7">
              Our advanced quality control systems are designed to maintain
              consistency, safety, and performance across every stage of
              nutraceutical manufacturing. Through strict monitoring,
              analytical testing, and process validation, we ensure every
              product meets global quality and compliance standards.
            </p>
          </div>

          {/* Right Image */}
          <div>
            <img
              src={imgrd6}
              alt="Quality Control"
              className="w-full h-[280px] sm:h-[420px] object-cover rounded-[40px]"
            />
          </div>
        </div>

        {/* Bottom Points */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12">

          {[qualityLeft, qualityRight].map((list, listIndex) => (
            <div
              key={listIndex}
              className="bg-[#f7faf5] rounded-3xl p-6 md:p-8 shadow-md"
            >
              <div className="space-y-5">
                {list.map((item, index) => (
                  <div key={index} className="flex gap-3 items-start">
                    <BadgeCheck
                      size={20}
                      className="text-[#355931] mt-1 shrink-0"
                    />
                    <p className="text-gray-700 text-sm md:text-base leading-6 text-left">
                      {item}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
};

export default Research_Development_fifth;